var routes = {
  HOME: "/",
  // GAMEPLAY: "/gameplay/[PATH]",
  GAMEPLAY: "/onboarding",
  USER_SUBSCRIBE: "/user/subscribe",
  USER_SUBSCRIBE_CANCEL: "/user/optinCancel",
  USER_SUBMIT_PASSWORD: "/ssoproxy/createpassword",
  GIFTPACK: "/giftpack",
  SGP_SHARE_FACEBOOK: '/giftpack/award/facebook',
  SGP_SHARE_TWITTER: '/giftpack/award/twitter',
  SGP_SHARE_COPY: '/giftpack/award/copy',
  API: {
    TUTORIAL: "/tutorial",
    RESULTS: "/keno/results",
    NOTIFY: "/keno/notify",
    CLEAR_NOTIFICATION: "/notification/"
  }
};

function addRoute(name, url) {
  routes[name] = url;
}

export { addRoute };
export default routes;
